<template>
  <div class="textarea-input clearfix">
    <div v-show="show" class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label
      :for="options.name"
      :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <textarea
          :class="formControlValidationClass"
          :placeholder="options.placeholder"
          :id="options.name"
          class="form-control"
          type="text" :value="value"
          :name="options.name"
          :style="{ minHeight: options.height || '100px' }"
          @input="validate($event.target.value)">
        </textarea>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  formControlValidationClass,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'TextareaInput',
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: '',
          required: false,
          placeholder: '',
          show: true
        }
      }
    }
  },
  data () {
    return {
      show: true,
      isLength: true,
      isRegex: true,
      isValid: false,
      isDirty: false,
      minLength: 1,
      invalidMessage: this.options.label + ' is required'
    }
  },
  computed: {
    validationClass,
    formControlValidationClass,
    validationMessage
  },
  mounted () {
    if (this.options.show || this.options.show === false) {
      this.show = this.options.show
    }
    this.validate(this.value)
    this.isDirty = false
  },
  methods: {
    validate (val = this.value) {
      this.$emit('input', val)
      if (val) {
        this.isLength = this.isValid = val.length >= this.minLength
        this.isDirty = true
      } else if (this.options.required) {
        this.isValid = false
        this.isDirty = true
      } else {
        this.isValid = true
      }
    },
    runWatcher (val, name) {
      if (this.options.watchers.includes(name)) {
        switch (name) {
          case 'acceptedPBG':
            if (val) this.validate(this.options.defaultText || '')
            this.show = !val
            this.options.required = !val
            break
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/TextareaInput.vue